// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-product-detail-tsx": () => import("./../../../src/templates/product-detail.tsx" /* webpackChunkName: "component---src-templates-product-detail-tsx" */),
  "component---src-templates-product-guide-tsx": () => import("./../../../src/templates/product-guide.tsx" /* webpackChunkName: "component---src-templates-product-guide-tsx" */)
}

